import React from "react";
import {BooleanInput, Edit, SaveButton, SimpleForm, TextInput, useRedirect} from "react-admin";
import {HStack, Text, VStack} from "@chakra-ui/react";
import {ArrowBackIcon} from "@chakra-ui/icons";

const UserEdit = (props: any) => {
    const redirect = useRedirect();

    return (
        <VStack w={"full"} h={"full"} alignItems={'stretch'}>
            <HStack alignItems={"center"} p={"16px"} alignSelf={'flex-start'} _hover={{
                backgroundColor: "tertiary.200",
                borderRadius: "16px",
            }} cursor={"pointer"} onClick={() => {
                redirect("/users");
                // navigate("/users", {replace: true});
            }}>
                <ArrowBackIcon/>
                <Text fontWeight={"bold"}>Indietro</Text>
            </HStack>
            <Edit {...props}>
                <SimpleForm sx={{maxWidth: 600, mx: "auto"}}>
                    <TextInput source="id" label="ID" disabled readOnly contentEditable={false} sx={{width: '100%'}}/>
                    <TextInput source="email" label="Email" sx={{width: '100%'}}/>
                    <TextInput source="userType" label="Tipologia Utente" sx={{width: '100%'}}/>
                    <TextInput source="mobileNumber" label="Numero di Telefono" sx={{width: '100%'}}/>
                    <BooleanInput source="isVerified" label="Email Verificata" sx={{width: '100%'}}/>
                    <SaveButton sx={{width: '100%', mt: 2}} label={"SALVA"}/>
                </SimpleForm>
            </Edit>
        </VStack>
    );
};

export default UserEdit;
